import { reactive, toRaw } from 'vue';
import { getBriefList, getIamBriefList } from '../../api/brief';
import { isN } from '../../utils/tools';
import { getDataBySubkey, getIndexDbDicService, setIndexDbDic } from '../indexDb';

import ss from '../sessionStorage';
import { useUserStore } from './user';

export const useBriefStore = {
  async getServiceBrief() {
    const userStore = useUserStore();

    let ver = await getIndexDbDicService('dicService', 'group', 'ver');
    const val = await getBriefList(ver);
    //如果网络请求失败，val会未定义，且内部toast错误了，因此这里直接返回不再处理
    if(isN(val)){
      return;
    }

    const { code = -1, value = {} } = val;
    // console.log('++++++++++++++++++++++val',ver);
    
    if (code === 0) {
      const { dicVer= '', dicService={}, rool = {} } = value;
      const dictMap: Record<string, Record<string, string>> = {};
      //存储用户在该部门的角色信息--直接存储，覆盖之前的
      // setKeyJsonStr(authCacheNaem, {'rool': rool});
      userStore.rool = toRaw(rool);

      //如果有dicService且必须有值，就更新
      if(dicService !== null && Object.keys(dicService).length > 0){
        //把新的版本存进去
        setIndexDbDic('dicService', 'group', dicVer, dicService);
        userStore.dic = reactive({ ...dicService });
        // 2025-08-20 新增
        // 用于表格字典映射,因为表格列是字典时，解析速度太慢，所以添加这个map
        // 在添加map之前，需要从dic中查询，通过find的方式，找到对应的字典的对应label。
        // 添加了map之后可以直接通过[dicname][v]直接对应label，
        // 因为表格映射只需要通过value获取label
        Object.entries(dicService).forEach(([dictName, items]) => {
          dictMap[dictName] = {};
          if (Array.isArray(items)){
            items.forEach(item => {
              const { label, value } = item;
              dictMap[dictName][value] = label; // value → label
            });
          }
        });
        userStore.dicMap = dictMap;
      }
    } else {
      const einfo = `[${userStore.ctxt}/brief] ${value}`;
      console.error(einfo);
      throw einfo;
    }
  },

  async getIamBrief() {
    const userStore = useUserStore();
    const { code = -1, value = {} } = await getIamBriefList();
    if (code === 0) {
      const { dicIam={}, arc, arc1, aid} = value;
      ss.setKey('dicIam', dicIam);

      //uinfo更新用户的部门信息
      let lsuinfo = userStore.uinfo;
      if(isN(lsuinfo)){
        console.error('此时不应丢失用户信息');
        lsuinfo = {};
      }
      lsuinfo['arc'] = arc;
      lsuinfo['arc1'] = arc1;
      lsuinfo['aid'] = aid;
      // setKeyJsonStr('uinfo', lsuinfo);
      userStore.uinfo = toRaw(lsuinfo);
    } else {
      const einfo = `[iam] ${code} ${value}`;
      console.error(einfo);
      throw einfo;
    }
  },

  dicService(dicName:string, exclude:boolean){
    getIndexDbDicService('dicService', 'group', dicName).then((v:any[]) => {
      //如果排除{}这种值，就不要{}这种的
      if(exclude){
        return v.filter(its => `${its['label']}` !== `{}`);
      }
      return v;
    });

    //return [];
    //return ss.getKey2Json('dicService');
  },

  //iam的字典目前不多，就放在会话中，不做更新
  dicIam(key:string){
    return ss.getKey2JsonWithSub('dicIam', key);
  },

  dicServiceSubkey(dicName:string, exclude:boolean, subkey:Array<string>){
    getDataBySubkey('dicService', 'group', dicName, subkey).then((v:any[]) => {
      //如果排除{}这种值，就不要{}这种的
      if (exclude) {
        return v.filter(its => `${its['label']}` !== `{}`);
  }
      return v;
    });

    //return [];
    //return ss.getKey2Json('dicService');
  },

};
//export default useBriefStore;
